<template>
  <IntroAtcEnhancedV2
    v-if="displayNewInteraction"
    :image
    :price
    :price-without-trade-in
    :product-title
    @close="emit('close')"
    @next-step="emit('next-step')"
  />
  <IntroAtcIso
    v-else
    :close-wording
    :price
    @close="emit('close')"
    @next-step="emit('next-step')"
  />
</template>

<script lang="ts" setup>
import type { Price } from '@backmarket/http-api'
import type { GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import IntroAtcEnhancedV2 from './IntroAtcEnhancedV2.vue'
import IntroAtcIso from './IntroAtcIso.vue'

interface IntroAtcProps {
  price?: Price
  priceWithoutTradeIn?: Price
  closeWording: string
  image?: GetProductResponse['images'][number]
  productTitle?: string
}

const experiments = useExperiments()

defineProps<IntroAtcProps>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'next-step'): void
}>()

const displayNewInteraction =
  experiments['experiment.introAtcInteractionV2'] ===
    'withNewAtcSwapAnimated' ||
  experiments['experiment.introAtcInteractionV2'] === 'withNewAtcSwapImage'
</script>
